/**
 * Locale configuration shared between app and build tools
 * Single source of truth for all language-related configuration
 */

// TODO: Add translation files for other languages before enabling them
// Currently only en-US has complete translation files
export const SUPPORTED_LANGUAGES = [
  'en-US', // English (US) - ✅ Translation files available
  'zh-CN', // 简体中文 (Chinese Simplified) - ✅ Translation files available
  'en-GB', // English (UK) - ⚠️ Translation files missing
  // 'fr-FR', // Français (France) - ⚠️ Translation files missing
  // 'es-ES', // Español (Spain) - ⚠️ Translation files missing
  // 'pt-PT', // Português (Portugal) - ⚠️ Translation files missing
  // 'it-IT', // Italiano (Italy) - ⚠️ Translation files missing
  // 'zh-TW', // 繁體中文 (Chinese Traditional) - ⚠️ Translation files missing
  // 'pl-PL', // Polski (Poland) - ⚠️ Translation files missing
  // 'id-ID', // Bahasa Indonesia (Indonesia) - ⚠️ Translation files missing
  // 'vi-VN', // Tiếng Việt (Vietnamese) - ⚠️ Translation files missing
  // 'ro-RO', // Română (Romania) - ⚠️ Translation files missing
  // 'ru-RU', // Русский (Russia) - ⚠️ Translation files missing
  // 'de-DE', // Deutsch (Germany) - ⚠️ Translation files missing
  // 'no-NO', // Norsk (Norwegian) - ⚠️ Translation files missing
  // 'sv-SE', // Svenska (Swedish) - ⚠️ Translation files missing
  // 'da-DK', // Danish - ⚠️ Translation files missing
  // 'hu-HU', // Magyar (Hungary) - ⚠️ Translation files missing
  // 'hi-IN', // हिन्दी (India) - ⚠️ Translation files missing
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en-US';

export const languageNames = {
  'en-GB': 'English (UK)',
  'en-US': 'English (US)',
  'fr-FR': 'Français',
  'es-ES': 'Español',
  'pt-PT': 'Português',
  'it-IT': 'Italiano',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  'pl-PL': 'Polski',
  'id-ID': 'Bahasa Indonesia',
  'vi-VN': 'Tiếng Việt',
  'ro-RO': 'Română',
  'ru-RU': 'Русский',
  'de-DE': 'Deutsch',
  'no-NO': 'Norsk',
  'sv-SE': 'Svenska',
  'da-DK': 'Danish',
  'hu-HU': 'Magyar',
  'hi-IN': 'हिन्दी',
};
